import * as React from "react";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Tooltip } from "primereact/tooltip";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getBank } from "../../StateManagement/BankSlice";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { logoutStatic } from "../../StateManagement/authSlice";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { DropDownFormat } from "../../Landing/Components/FormOptions/DropDownFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData, formatNumber, getFilterButton, getFilterClearButton, getFilterInputText, getFilterSelect } from "../Components/Utilities";
import { Col, Row } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SelectFormat from "../../Landing/Components/FormOptions/SelectFormat";
import DatePickerFormat from "../../Landing/Components/FormOptions/DatePickerFormat";

export const Users = () => {
  const [loading, setLoading] = useState(false);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const editComponentRef = useRef(null);
  const dispatch = useDispatch();
  const bank = useSelector((state) => state?.bank?.bank);
  const province = useSelector((state) => state?.province?.province);
  const navigate = useNavigate();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [educationList, setEducationLis] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      name: { value: "", matchMode: "contains" },
      Mob: { value: "", matchMode: "contains" },
      groupid: { value: null, matchMode: FilterMatchMode.IN },
      sex: { value: null, matchMode: FilterMatchMode.IN },
      org: { value: null, matchMode: FilterMatchMode.IN },
    },
  });
  const [banksList, setbanksList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const sexList = [
    { value: "1", label: "مرد" },
    { value: "2", label: "زن" },
  ];
  const statusList = [
    { value: "0", label: "غیرسازمانی" },
    { value: "1", label: "سازمانی" },
  ];

  const defaultValues = {
    mobrt: "",
    ACCno: "",
    Address: "",
    BirthDay: new Date(),
    Born: "",
    CartNo: "",
    CityId: "",
    lastseen: "",
    Email: "",
    FatherName: "",
    IdOfReAgent: "",
    InsPay: 0,
    Job: "",
    PassWord: "",
    PostalCode: "",
    ProvinceId: "",
    Sheba: "",
    Tel: "",
    addTitle: "",
    coin: "",
    edu: "",
    family: "",
    grade: "",
    idcode: "",
    idofbank: "",
    latlong: "",
    name: "",
    pic: "",
    sex: "",
    shsh: "",
    Mob: "",
    referral: "",
    uid: "",
    regdate: "",
    no: "",
    unit: "",
    groupid: "",
  };
  const schema = yup.object({
    Mob: yup
      .string()
      .required("شماره موبایل وارد نشده است.")
      .min(11, "شماره موبایل نمی تواند کمتر از 11 کاراکتر باشد."),
    name: yup.string().required("نام وارد نشده است."),
    family: yup.string().required("نام خانوادگی وارد نشده است."),
  });
  const yourGroupOptions = userList.map((user) => user);
  const {
    watch,
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  // const getFilterButton = (option) => (
  //   <Button onClick={() => option.filterApplyCallback(option.filterModal)}>
  //     اعمال
  //   </Button>
  // );

  // const getFilterSelect = (options, list, key, placeholder) => (
  //   <select
  //     id={key}
  //     name={key}
  //     defaultValue=""
  //     className="form-control"
  //     value={lazyState.filters[key].value}
  //     onChange={(e) => options.filterCallback(e.target.value)}
  //   >
  //     <option value="" disabled>
  //       {placeholder}
  //     </option>
  //     {list?.map((item) => (
  //       <option key={item.value} value={item.value}>
  //         {item?.label}
  //       </option>
  //     ))}
  //   </select>
  // );

  // const getFilterInputText = (options, placeholder) => (
  //   <InputText
  //     value={options.value}
  //     onChange={(e) => options.filterCallback(e.target.value)}
  //     // optionLabel="موبایل"
  //     placeholder={placeholder}
  //     className="p-column-filter"
  //   />
  // );

  // const getFilterClearButton = (options) => (
  //   <Button
  //     type="button"
  //     icon="pi pi-times"
  //     className="btn btn-danger"
  //     onClick={options.filterClearCallback}
  //     severity="secondary"
  //   >
  //     حذف فیلتر
  //   </Button>
  // );
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "name",
      header: "نام و نام خانوادگی",
      body: (data, options) => data?.Name + " " + data?.Family,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    {
      field: "sex",
      header: "جنسیت",
      body: (data) => (data?.sex === 1 ? "مرد" : "زن"),
      filter: true,
      filterPlaceholder: "جنسیت را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(options, sexList, "sex", "جنسیت را انتخاب کنید"),
      filterClear: getFilterClearButton,
    },
    {
      field: "Mob",
      header: "شماره ",
      filter: true,
      filterPlaceholder: "شماره را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "شماره را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    {
      field: "groupid",
      header: "گروه",
      body: (data) => data.groupid.split("|")[1],
      filter: true,
      filterPlaceholder: "گروه را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(options, groupList, "groupid", "گروه را انتخاب کنید"),
      filterClear: getFilterClearButton,
    },
    {
      field: "org",
      header: "وضعیت",
      body: (data) => {
        return data?.org === 1 ? "سازمانی" : "غیرسازمانی";
      },
      filter: true,
      filterPlaceholder: "وضعیت را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(options, statusList, "org", "وضعیت را انتخاب کنید"),
      filterClear: getFilterClearButton,
    },
    { field: "plan", header: "وضعیت بیمه نامه" ,   body: (data) => {
      if(data?.plan === 0){
        return "عدم پرداخت ";
      } else if(data?.plan === 1){
        return "پرداخت حق عضویت";
      } else {
        return "پرداخت تکمیل";
      }
    }},
    { field: "RegDate", header: "تاریخ عضویت" },
    { field: "lastseen", header: " آخرین ورود" },
    { field: "ProvinceName", header: "استان" },
    { field: "CityName", header: "شهر" },
    {
      field: "coin",
      header: "تعداد سکه",
      body: (data) => (
        <div style={{ direction: "ltr", textAlign: "center" }}>
          <a
            className="text-decoration-underline"
            onClick={() => navigate(`/cpanel/users/${data?.uid}`)}
          >
            {formatNumber(data?.coin)}
          </a>
        </div>
      ),
    },
    {
      field: "referral",
      header: "تعداد زیرمجموعه مستقیم",
      body: (data) => (
        <a
          className="text-decoration-underline"
          onClick={() => navigate(`/cpanel/users/detail/${data?.uid}`)}
        >
          {data?.referral}
        </a>
      ),
    },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchData("edu", {}, handleEducationApiResponse);
    fetchData("grouplist", {}, handleGroupApiResponse);
  }, []);
  let networkTimeout = null;
  useEffect(() => {
    loadLazyData(lazyState);
  }, [lazyState]);
  const handleEducationApiResponse = (data) => {
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.EduId.toString(),
        label: item.EduTitle,
      }));
    };
    const formattedOptions = mapOptions(data?.dt);
    setEducationLis(formattedOptions);
  };
  const handleGroupApiResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.id.toString(),
        label: item.groupname,
      }));
    };
    const formattedOptions = mapCats(data?.dt);
    setGroupList(formattedOptions);
  };
  const statusOptions = [
    { value: 1, label: "سازمانی" },
    { value: 2, label: "غیر سازمانی " },
  ];
  const loadLazyData = (data) => {
    setLoading(true);
    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      const bodyFormData = new FormData();
      bodyFormData.append("guid", Cookies.get("guid"));
      bodyFormData.append("pageNo", data?.page + 1 ?? 1);
      bodyFormData.append("pageSize", data?.rows ?? 20);
      if (data?.filters?.name?.value) {
        bodyFormData.append("name", data?.filters?.name?.value);
      }
      if (data?.filters?.groupid?.value) {
        bodyFormData.append("groupid", data?.filters?.groupid?.value);
      }
      if (data?.filters?.sex?.value) {
        bodyFormData.append("sex", data?.filters?.sex?.value);
      }
      if (data?.filters?.Mob?.value) {
        bodyFormData.append("mob", data?.filters?.Mob?.value);
      }
      if (data?.filters?.org?.value) {
        bodyFormData.append("org", data?.filters?.org?.value);
      }
      const handleApiResponse = (data) => {
        setTotalRecords(data?.count);
        setUserList(data?.dt);
        setLoading(false);
      };
      fetchData("userlist", bodyFormData, handleApiResponse);
    }, Math.random() * 1000 + 250);
  };

  const fetchUserData = async (id, rowData) => {
    const handleApiResponse = (data) => {
      const userData = data?.userinfo;
      console.log(userData);
      reset({
        ...defaultValues,
        ...Object.keys(userData).map(
          (key) => userData[key] || defaultValues[key]
        ),
        Mob: rowData?.Mob,
        referral: rowData?.referral,
        uid: rowData?.uid,
        Address: userData?.Address?.split("|")[0],
        no: userData?.Address?.split("|")[1],
        unit: userData?.Address?.split("|")[2],
        BirthDay: new Date(userData?.BirthDay) || new Date(),
      });
    };
    const bodyFormData = new FormData();
    bodyFormData.append("uid", id);
    fetchData("guid", bodyFormData, handleApiResponse);
  };
  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("ProvinceId"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("ProvinceId")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
    });
  }, [watch("ProvinceId")]);

  const handleOpeEditItem = (data) => {
    try {
      console.log(data, "data");
      if (data) {
        fetchUserData(data?.uid, data);
        setSelectedUserId(data?.uid);
        setIsEditMode(true);
      } else {
        reset(defaultValues);
        setIsEditMode(false);
      }
      setShowEditComponent(false);
      setTimeout(() => {
        setShowEditComponent(true);
      }, 0);
      dispatch(getBank());
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item?.BankId.toString(),
          label: item?.BankTitle,
        }));
      };
      const datas = mapOptions(bank);
      setbanksList(datas);
      dispatch(getProvince());
      const proviceOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.provinceid,
          label: item.provincename,
        }));
      };
      const provinceData = proviceOptions(province);
      setProvinceList(provinceData);
    } catch (e) {
      console.log(e);
    }
  };

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const handleOpenDisableUsers = () => {
    navigate("/cpanel/disableusers");
  };
  const handleExcelGetUsers = () => {
    navigate("/cpanel/addusersfromexcel");
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const excelList = userList.map((item) => ({
        "شناسه کاربر": item.uid,
        نام: item.Name,
        "نام خانوادگی": item.Family,
        "شماره موبایل": item.Mob,
        "تاریخ عضویت": item.RegDate,
        گروه: item.groupid,
        "تعداد زیر مجموعه": item.referral,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const header = (
    <div className="d-flex flex-wrap align-items-center justify-content-between dt-header">
      <FontAwesomeIcon
        onClick={exportExcel}
        className="p-2 rounded  bg-info text-white"
        icon={"file-excel"}
      />
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-1">
        <Button
          type={"button"}
          className=" btn-secondary "
          onClick={() => navigate("/cpanel/supportList")}
        >
          لیست حمایت ها
        </Button>
        <Button
          type={"button"}
          className="btn-info"
          onClick={() => navigate("/cpanel/users/treeview")}
        >
          نمایش درختی
        </Button>
      </div>
    </div>
  );

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("name", data?.name);
    bodyFormData.append("family", data?.family);
    bodyFormData.append("sex", data?.sex);
    bodyFormData.append("BirthDay", new Date(data?.BirthDay));
    bodyFormData.append("Mob", data?.Mob);
    bodyFormData.append("idcode", data?.idcode);
    bodyFormData.append("shsh", data?.shsh);
    bodyFormData.append("Born", data?.Born);
    bodyFormData.append("FatherName", data?.FatherName);
    bodyFormData.append("edu", data?.edu);
    bodyFormData.append("Job", data?.Job);
    bodyFormData.append("Email", data?.Email);
    bodyFormData.append("PassWord", data?.PassWord);
    bodyFormData.append("bankid", data?.idofbank);
    bodyFormData.append("accno", data?.ACCno);
    bodyFormData.append("cartno", data?.CartNo);
    bodyFormData.append("sheba", data?.Sheba);
    bodyFormData.append("provinceId", data?.ProvinceId);
    bodyFormData.append("cityId", data?.CityId);
    bodyFormData.append("postalcode", data?.PostalCode);
    bodyFormData.append(
      "address",
      data?.Address + "|" + data?.no + "|" + data?.unit
    );
    bodyFormData.append("groupid", data?.groupid ?? 0);

    let cmd = "createuser";
    if (selectedUserId) {
      bodyFormData.append("uid", selectedUserId);
      bodyFormData.append("mobrt", data?.mobrt);
      cmd = "updateuser";
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
          dispatch(logoutStatic());
          navigate("/");
        }
        SweetAlert({
          title: "",
          text: selectedUserId
            ? "اطلاعات با موفقیت به روز رسانی شد"
            : "کاربر جدید اضافه شد.",
          type: "success",
        });
        loadLazyData(lazyState);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  useEffect(() => {
    if (showEditComponent && editComponentRef.current) {
      editComponentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [showEditComponent]);
  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
    console.log(event, "on filter");
  };

  const formFields = [
    [
      {
        Component: TelInput,
        name: "mobrt",
        type: "tel",
        label: "شماره موبایل معرف",
        maxLength: 11,
      },
      {
        Component: TelInput,
        name: "Mob",
        type: "tel",
        label: "شماره موبایل",
        
        required: true,
        maxLength: 11,
      },
    ],
    [
      {
        Component: InputFormat,
        name: "name",
        type: "text",
        label: "نام",
        required: true,
      },
      {
        Component: InputFormat,
        name: "family",
        type: "text",
        label: "نام خانوادگی",
        required: true,
      },
    ],
    [
      {
        Component: SelectFormat,
        name: "sex",
        control: control,
        label: "جنسیت",
        options: sexList,
        errors: errors,
        name: "sex",
        placeholder: "جنسیت را انتخاب کنید",
      },
      {
        Component: DatePickerFormat,
        name: "BirthDay",
        control,
        label: "تاریخ تولد",
        errors: errors,
      },
    ],
    [
      { Component: TelInput, name: "idcode", type: "tel", label: "کدملی" },
      {
        Component: TelInput,
        name: "shsh",
        type: "tel",
        label: "شماره شناسنامه",
        maxLength: 10,
      },
    ],
    [
      {
        Component: InputFormat,
        name: "FatherName",
        type: "text",
        label: "نام پدر",
      },
      { Component: InputFormat, name: "Born", type: "text", label: "محل تولد" },
    ],
    [
      {
        Component: DropDownFormat,
        control: control,
        label: "تحصیلات",
        options: educationList,
        errors: errors,
        name: "edu",
      },
      {
        Component: InputFormat,
        control: control,
        name: "Job",
        type: "text",
        label: "شغل",
      },
    ],
    [
      {
        Component: InputFormat,
        control: control,
        name: "Email",
        type: "text",
        label: "ایمیل",
      },
      {
        Component: InputFormat,
        control: control,
        name: "PassWord",
        type: "password",
        label: "رمز عبور",
      },
    ],
    [
      {
        Component: DropDownFormat,
        control: control,
        label: "بانک",
        options: banksList,
        errors: errors,
        name: "idofbank",
      },
      {
        Component: TelInput,
        control: control,
        name: "ACCno",
        type: "tel",
        label: "شماره حساب",
        maxLength: 14,
      },
    ],
    [
      {
        Component: TelInput,
        control: control,
        name: "CartNo",
        type: "tel",
        label: "شماره کارت",
        maxLength: 16,
      },
      {
        Component: InputFormat,
        control: control,
        name: "Sheba",
        type: "text",
        label: "شبا",
      },
    ],
    [
      {
        Component: DropDownFormat,
        control: control,
        label: "استان",
        options: ProvinceList,
        errors: errors,
        name: "ProvinceId",
      },
      {
        Component: DropDownFormat,
        control: control,
        label: "شهر",
        options: cityList,
        errors: errors,
        name: "CityId",
      },
    ],
    [
      {
        Component: TelInput,
        label: "کد پستی",
        type: "text",
        name: "PostalCode",
        control: control,
      },
    ],
    [
      {
        Component: InputFormat,
        control: control,
        name: "Address",
        type: "textarea",
        label: "آدرس",
      },
      {
        Component: InputFormat,
        control: control,
        name: "no",
        type: "text",
        label: "پلاک",
        className: "col-3 col-md-4",
      },
      {
        Component: InputFormat,
        control: control,
        name: "unit",
        type: "text",
        label: "واحد",
        className: "col-3",
      },
    ],
  ];
  return (
    <>
      {/* <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2 mb-1"
        onClick={() => navigate('/cpanel/dashboard')}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button> */}
      <PanelContainer title={"کاربران"}>
        <Tooltip target=".export-buttons>button" position="bottom" key="" />
        <DataTableTemplate
          lazyState={lazyState}
          lazy
          // select={true}
          className={"table-border"}
          columns={cols}
          list={userList}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          defaultDatatableRows={defaultDatatableRows}
          width="20rem"
          header={header}
          onFilter={onFilter}
          filters={lazyState.filters}
          loading={loading}
          onPage={onPage}
          // setSelectedProducts
          // selectedProducts
        />

        <div className="col-6">
          <div className="d-flex flex-row gap-1 mt-2 flex-wrap">
            <Button className="btn-primary" onClick={() => handleOpeEditItem()}>
              افزودن کاربر جدید
            </Button>
            <Button
              className="btn-success"
              onClick={() => handleExcelGetUsers()}
            >
              افزودن کاربر توسط اکسل
            </Button>
            <Button
              className="btn-info"
              onClick={() => handleOpenDisableUsers()}
            >
              کاربران غیرفعال(10)
            </Button>

            <Button
              className="btn-secondary"
              onClick={() => navigate("/cpanel/category")}
            >
              افزودن گروه بندی جدید
            </Button>
          </div>
        </div>
        {showEditComponent && (
          <div ref={editComponentRef} className="edit ">
            <div className="panel-heading prime-bg text-white text-center py-2 m-2">
              <span id="ContentPlaceHolder1_lblbannerheading ">
                {isEditMode ? "ویرایش کاربر" : "ایجاد کاربر جدید"}
              </span>
            </div>
            <div className="edit row pt-5">
              <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
                <Row className="d-flex align-items-center">
                  <Col className=" col-12 col-lg-6">
                    <DropDownFormat
                      control={control}
                      label={"گروه"}
                      options={groupList}
                      errors={errors}
                      name={"groupid"}
                    />
                  </Col>
                  <Col className=" col-12 col-lg-6">
                    <DropDownFormat
                      control={control}
                      label={"وضعیت"}
                      options={statusList}
                      errors={errors}
                      name={"groupid"}
                    />
                  </Col>
                </Row>
                {formFields.map((rowFields, rowIndex) => (
                  <Row key={rowIndex}>
                    {rowFields.map(({ Component, ...fieldProps }, colIndex) => (
                      <Col
                        key={colIndex}
                        className={
                          Component?.className
                            ? Component?.className
                            : "col-12 col-lg-6"
                        }
                      >
                        <Component
                          control={control}
                          errors={errors}
                          register={register}
                          {...fieldProps}
                        />
                      </Col>
                    ))}
                  </Row>
                ))}
                <div className="col-12 d-flex justify-content-end  align-items-center">
                  <Button type="submit">ذخیره</Button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </PanelContainer>
    </>
  );
};
